<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container containerApply">
      <asideCom :activityIndex="1"></asideCom>
      <div class="apply-content">
        <div class="name">{{ $t("people.认证管理") }}</div>
        <div class="top-choose">
          <div
            class="message"
            :class="{ choose: contentIndex == 0 }"
            @click="changeIndex(0)"
          >
            {{ $t("global.个人认证") }}
          </div>
          <div
            class="modify-password"
            :class="{ choose: contentIndex == 1 }"
            @click="changeIndex(1)"
          >
            {{ $t("global.企业认证") }}
          </div>
        </div>
        <div class="basic-message" v-if="contentIndex == 0">
          <div class="identtips" v-if="status == 2 && companyStatus != 2">
            {{ $t("global.你的个人认证信息已审核通过") }}，{{
              $t("global.恭喜你成为我们尊贵的个人认证会员")
            }}！
          </div>
          <div class="identtips" v-if="status == 1 && companyStatus != 2">
            {{ $t("global.个人认证信息审核中") }}
          </div>
          <div class="identtips" v-if="companyStatus == 2">
            {{ $t("global.你的企业认证信息已审核通过") }}，{{
              $t("global.恭喜你成为我们尊贵的企业认证会员")
            }}！
          </div>
          <template v-if="(status == 0 || status == 3) && companyStatus != 2">
            <div class="message-top">{{ $t("global.信息认证") }}</div>
            <el-form :rules="rules" :model="form">
              <el-form-item prop="realName">
                <div class="contain">
                  <div class="left">
                    <div class="font">
                      {{ $t("global.姓名") }}
                      <span class="tips">*{{ $t("global.必填") }}</span>
                    </div>
                    <el-input
                      type="text"
                      :disabled="!isShow"
                      class="real-name"
                      v-model="form.realName"
                      :placeholder="$t('global.请输入姓名')"
                    ></el-input>
                  </div>
                </div>
              </el-form-item>
              <el-form-item prop="idcardCode">
                <div class="contain">
                  <div class="left">
                    <div class="font">
                      {{ $t("global.身份证") }}
                      <span class="tips">*{{ $t("global.必填") }}</span>
                    </div>
                    <el-input
                      type="text"
                      :disabled="!isShow"
                      class="real-name"
                      v-model="form.idcardCode"
                      :placeholder="$t('global.请输入身份证号码')"
                    ></el-input>
                  </div>
                </div>
              </el-form-item>

              <div class="contain">
                <div class="left">
                  <div class="font">{{ $t("global.地区") }}</div>
                  <div class="special">
                    <el-form-item prop="country">
                      <el-select
                        v-model="form.country"
                        :disabled="!isShow"
                        filterable
                        :placeholder="$t('global.请选择地区')"
                        class="elselect"
                      >
                        <el-option
                          v-for="(item, index) in options"
                          :key="index"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <el-form-item prop="area">
                    <el-input
                      type="text"
                      :disabled="!isShow"
                      class="city"
                      v-model="form.area"
                      :placeholder="$t('global.请输入城市')"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <!-- <el-form-item prop="phone">
                <div class="contain">
                  <div class="left">
                    <div class="font">
                      {{$t('global.手机号')}}
                      <span class="tips">*{{$t('global.必填')}}</span>
                    </div>
                    <el-input
                      type="text"
                      :disabled="!isShow"
                      class="real-name"
                      v-model="form.phone"
                      :placeholder="$t('global.请输入手机号')"
                    ></el-input>
                  </div>
                </div>
              </el-form-item>

              <el-form-item prop="code">
                <div class="contain reset-contain" v-if="isShow">
                  <div class="left">
                    <div class="font">
                      {{$t('global.验证码')}}
                      <span class="tips">*{{$t('global.必填')}}</span>
                    </div>
                    <el-input
                      type="text"
                      :disabled="!isShow"
                      v-model="form.code"
                      class="real-name"
                      :placeholder="$t('global.请输入验证码')"
                    ></el-input>
                  </div>
                  <div class="right">
                    <div class="font"></div>
                    <span
                      v-if="isShow"
                      class="button reset-button"
                      @click="sendSms"
                      style="display: inline-block"
                    >{{buttonText}}</span>
                  </div>
                </div>
              </el-form-item> -->
            </el-form>
            <div class="people-upload">
              <div class="upload-head">
                {{ $t("global.信息认证") }}
                <span class="tips">*{{ $t("global.必填") }}</span>
              </div>
              <div class="upload-content">
                <div class="upload-left">
                  <div
                    class="upIMG Backimg"
                    v-if="idcardPersonImage != ''"
                    :style="
                      idcardPersonImage
                        | bgImageUrl('', '/static/manageCenter/front.png')
                    "
                  ></div>
                  <div class="upIMG Backimg" v-else>
                    {{ $t("global.上传证件照") }}
                  </div>
                  <div class="front-font">
                    {{ $t("works.上传手持证件照正面") }}（{{
                      $t("global.10M以内")
                    }}）
                  </div>
                  <div
                    v-if="isShow"
                    class="button reset-button"
                    @click="changeInput(6)"
                  >
                    {{ $t("global.点击上传") }}
                  </div>
                </div>
                <div class="upload-right">
                  <div
                    class="upIMG Backimg"
                    v-if="idcardImageFront != ''"
                    :style="
                      idcardImageFront
                        | bgImageUrl('', '/static/manageCenter/front.png')
                    "
                  ></div>
                  <div class="upIMG Backimg" v-else>
                    {{ $t("global.上传证件照") }}
                  </div>
                  <div class="front-font">
                    {{ $t("global.上传证件照正面") }}（{{
                      $t("global.10M以内")
                    }}）
                  </div>
                  <div
                    v-if="isShow"
                    class="button reset-button"
                    @click="changeInput(1)"
                  >
                    {{ $t("global.点击上传") }}
                  </div>
                </div>
                <div class="upload-right">
                  <div class="upload-left">
                    <div
                      class="upIMG Backimg"
                      v-if="idcardImageBack != ''"
                      :style="
                        idcardImageBack
                          | bgImageUrl('', '/static/manageCenter/reverse.png')
                      "
                    ></div>
                    <div class="upIMG Backimg" v-else>
                      {{ $t("global.上传证件照") }}
                    </div>
                    <div class="front-font">
                      {{ $t("global.上传证件照反面") }}（{{
                        $t("global.10M以内")
                      }}）
                    </div>
                    <div
                      v-if="isShow"
                      class="button reset-button"
                      @click="changeInput(2)"
                    >
                      {{ $t("global.点击上传") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="request">
              <div class="request-head">{{ $t("global.证件要求") }}</div>
              <div class="request-content">
                1.{{
                  $t(
                    "global.需上传本人露脸手持二代身份证照片＋身份证反面照片（不需手持）"
                  )
                }}
              </div>
              <div class="request-content">
                2.{{ $t("global.证件必须在有效期内，有效期需在一个月以上") }}
              </div>
            </div>
            <div class="request">
              <div class="request-head">{{ $t("global.照片要求") }}</div>

              <div class="request-content">
                1.{{ $t("global.文字清晰可辨") }}
              </div>
              <div class="request-content">
                2.{{
                  $t(
                    "global.证件照上信息需完整且清晰可辨（无反光、遮挡、水印、证件套、logo等）"
                  )
                }}
              </div>
              <div class="request-content">
                3.{{
                  $t("global.申请人填写的“公司名称”需和提交证件照片信息一致")
                }}
              </div>
              <div class="request-content">
                4.{{
                  $t(
                    "global.证件必须真实拍摄，不能使用复印件，不能对镜（证件信息反转）拍摄"
                  )
                }}
              </div>
              <div class="request-content">
                5.{{
                  $t(
                    "global.确保照片完整（不缺边角），证件周围不允许加上边角框（如：加上红框等）"
                  )
                }}
              </div>
            </div>
            <div v-if="isShow" class="button summit-apply" @click="peopleIden">
              {{ $t("global.提交认证") }}
            </div>
          </template>
        </div>
        <div class="basic-message" v-if="contentIndex == 1">
          <div class="identtips" v-if="companyStatus == 2">
            {{ $t("global.你的企业认证信息已审核通过") }}，{{
              $t("global.恭喜你成为我们尊贵的企业认证会员")
            }}！
          </div>
          <div class="identtips" v-if="companyStatus == 1">
            {{ $t("global.企业认证信息审核中") }}
          </div>
          <template v-if="isCompanyShow">
            <div class="message-top">{{ $t("global.企业信息") }}</div>
            <div class="contain">
              <div class="left">
                <div class="font">{{ $t("global.公司名称") }}</div>
                <el-input
                  type="text"
                  :disabled="!isCompanyShow"
                  class="real-name"
                  :placeholder="$t('global.请输入公司名称')"
                  v-model="companyName"
                ></el-input>
              </div>
            </div>
            <div class="contain reset-contain">
              <div class="left">
                <div class="font">{{ $t("global.企业信用代码") }}</div>
                <el-input
                  type="text"
                  :disabled="!isCompanyShow"
                  class="real-name"
                  :placeholder="$t('global.请输入企业信用代码')"
                  v-model="companyCode"
                ></el-input>
              </div>
            </div>
            <div class="request">
              <div class="request-head">{{ $t("global.证件要求") }}</div>
              <div class="request-content">
                1.{{ $t("global.需上传企业工商营业执照") }}、{{
                  $t("global.组织机构代码证照")
                }}、{{ $t("global.商标注册证或商标注册受理通知书") }}
                {{ $t("global.上传证件照") }}
              </div>
              <div class="request-content">
                2.{{ $t("global.证件必须在有效期内，有效期需在一个月以上") }}
              </div>
            </div>
            <div class="request">
              <div class="request-head">{{ $t("global.照片要求") }}</div>

              <div class="request-content">
                1.{{ $t("global.文字清晰可辨") }}
              </div>
              <div class="request-content">
                2.{{
                  $t(
                    "global.证件照上信息需完整且清晰可辨（无反光、遮挡、水印、证件套、logo等）"
                  )
                }}
              </div>
              <div class="request-content">
                3.{{
                  $t("global.申请人填写的“公司名称”需和提交证件照片信息一致")
                }}
              </div>
              <div class="request-content">
                4.{{
                  $t(
                    "global.证件必须真实拍摄，不能使用复印件，不能对镜（证件信息反转）拍摄"
                  )
                }}
              </div>
              <div class="request-content">
                5.{{
                  $t(
                    "global.确保照片完整（不缺边角），证件周围不允许加上边角框（如：加上红框等）"
                  )
                }}
              </div>
            </div>
            <div class="people-upload">
              <div class="upload-head">{{ $t("global.信息认证") }}</div>
              <div class="upload-content">
                <div class="upload-right">
                  <div class="upload-left">
                    <div
                      class="upIMG Backimg"
                      v-if="licenseImage != ''"
                      :style="
                        licenseImage
                          | bgImageUrl('', '/static/manageCenter/enterCard.png')
                      "
                    ></div>
                    <div class="upIMG Backimg" v-else>
                      {{ $t("global.上传证件照") }}
                    </div>
                    <div class="front-font reset-font">
                      {{ $t("global.营业执照照片或扫描件") }}（{{
                        $t("global.10M以内")
                      }}）
                    </div>
                    <div
                      class="button reset-button"
                      v-if="isCompanyShow"
                      @click="changeInput(5)"
                    >
                      {{ $t("global.点击上传") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="button summit-apply enterprise-submit"
              v-if="isCompanyShow"
              @click="companyIden"
            >
              {{ $t("global.提交认证") }}
            </div>
          </template>
        </div>
      </div>
    </div>
    <input
      style="display: none"
      type="file"
      class="upInput"
      accept="image/*"
      @change="upImg"
    />
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";

export default {
  name: "manageCenter",
  metaInfo() {
    return {
      title: this.$t("global.申请认证") + " | MANA",
    };
  },
  data() {
    return {
      form: {
        idcardCode: "",
        realName: "",
        country: "",
        area: "",
        phone: "",
        code: "",
      },
      contentIndex: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      truePhone: "",
      status: "",
      companyStatus: "",
      idcardImageFront: "",
      idcardImageFront1: "",
      idcardImageBack: "",
      idcardImageBack1: "",
      idcardPersonImage: "",
      idcardPersonImage1: "",
      companyFront: "",
      companyFront1: "",
      companyBack: "",
      companyBack1: "",
      companyName: "",
      companyCode: "",
      licenseImage: "",
      licenseImage1: "",
      options: [],
      buttonText: this.$t("global.发送验证码"),
      sendFlag: true,
      sessionId: "",
      rules: {
        realName: [
          {
            required: true,
            message: this.$t("global.请输入姓名"),
            trigger: "blur",
          },
        ],
        idcardCode: [
          {
            required: true,
            message: this.$t("global.请输入身份证号码"),
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: this.$t("global.请选择地区"),
            trigger: "blur",
          },
        ],
        area: [
          {
            required: true,
            message: this.$t("global.请输入所在城市"),
            trigger: "blur",
          },
        ],
        // phone: [
        //   {
        //     required: true,
        //     message: this.$t("global.请输入手机号"),
        //     trigger: "blur"
        //   },
        //   {
        //     len: 11,
        //     message: this.$t("global.手机号格式不正确"),
        //     trigger: "blur"
        //   }
        // ],
        // code: [
        //   {
        //     required: true,
        //     message: this.$t("global.请输入验证码"),
        //     trigger: "blur"
        //   }
        // ]
      },
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
  },
  computed: {
    isShow() {
      return (
        (this.status === 0 || this.status === 3) &&
        (this.companyStatus == 0 || this.companyStatus == 3)
      );
    },
    isCompanyShow() {
      return this.companyStatus === 0 || this.companyStatus === 3;
    },
  },
  created() {
    if (this.$query.type) {
      this.contentIndex = this.$query.type;
    }
    this.companyMessage();
    this.personalMessage();
    this.getCountry();
  },
  methods: {
    getCountry() {
      this.$http.get("/api/common/country/list").then((response) => {
        this.options = response.data;
      });
    },
    changeIndex(index) {
      this.contentIndex = index;
    },
    changeInput(index) {
      this.$store.dispatch("setImgIndex", index);
      document.querySelector(".upInput").click();
    },
    upImg(e) {
      let param = new FormData();
      let $this = this;
      param.append("files", e.target.files[0]);
      if (e.target.files[0].type == "image/gif") {
        this.$message(this.$t('works.暂不支持GIF格式，请上传其它图片'));
        return
      }
      let size = e.target.files[0].size / 1024 / 1024 <= 10;
      if (!size) {
        this.$message(
          `${this.$t("global.请上传")}10M${this.$t("global.以内的图片")}`
        );
        return false;
      }
      let file_ = document.querySelector(".upInput");
      this.$jsonUtils.checkImageSize(
        file_,
        e.target.files[0],
        350,
        350,
        function (data) {
          if (data.state) {
            $this.$http
              .post("/api/common/upload/image/mark", param, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response) => {
                $this.$message({
                  message: response.message,
                  type: "success",
                });
                switch ($this.$store.state.imgIndex) {
                  case 1:
                    $this.idcardImageFront = response.data.key;
                    $this.idcardImageFront1 = response.data.markKey;
                    break;
                  case 2:
                    $this.idcardImageBack = response.data.key;
                    $this.idcardImageBack1 = response.data.markKey;
                    break;
                  case 3:
                    $this.companyFront = response.data.key;
                    $this.companyFront1 = response.data.markKey;
                    break;
                  case 4:
                    $this.companyBack = response.data.key;
                    $this.companyBack1 = response.data.markKey;
                    break;
                  case 5:
                    $this.licenseImage = response.data.key;
                    $this.licenseImage1 = response.data.markKey;
                    break;
                  case 6:
                    $this.idcardPersonImage = response.data.key;
                    $this.idcardPersonImage1 = response.data.markKey;
                    break;
                }
              });
          } else {
            $this.$message.info(
              $this.$t("global.文件大小不能小于") + "350 * 350"
            );
          }
        }
      );
    },
    personalMessage() {
      this.$http.get("/api/u/certification/personal/get").then((response) => {
        let data = response.data;
        this.form.realName = data.realName;
        this.form.idcardCode = data.idcardCode;
        this.form.country = data.country;
        this.form.area = data.area;
        this.form.phone = data.phone;
        this.form.code = data.code;
        this.idcardImageFront = data.idcardImageFront;
        this.idcardImageBack = data.idcardImageBack;
        this.idcardPersonImage = data.idcardPersonImage;
        this.status = data.status;
        if (this.companyStatus == 2 || this.companyStatus == 1) {
          this.form = {
            idcardCode: "",
            realName: "",
            country: "",
            area: "",
            phone: "",
            code: "",
          };
          this.idcardImageFront = "";
          this.idcardImageBack = "";
        }
      });
    },
    companyMessage() {
      this.$http.get("/api/u/certification/company/get").then((response) => {
        let data = response.data;
        this.companyCode = data.companyCode;
        this.companyName = data.companyName;
        this.companyFront = data.idcardImageFront;
        this.companyBack = data.idcardImageBack;
        this.licenseImage = data.licenseImage;
        this.companyStatus = data.status;
      });
    },
    peopleIden() {
      if (this.form.realName == "") {
        this.$message.error(this.$t("global.请输入姓名"));
        return;
      }
      if (this.form.idcardCode == "") {
        this.$message.error(this.$t("global.请输入身份证号码"));
        return;
      }
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(this.form.idcardCode) === false) {
        this.$message.error(this.$t("global.身份证格式不正确"));
        return;
      }
      if (this.form.country == "") {
        this.$message.error(this.$t("global.请选择国家"));
        return;
      }
      if (this.form.area == "") {
        this.$message.error(this.$t("global.请输入城市"));
        return;
      }
      // if (this.form.phone == "") {
      //   this.$message.error(this.$t("global.请输入手机号"));
      //   return;
      // }
      // if (this.form.code == "") {
      //   this.$message.error(this.$t("global.请输入验证码"));
      //   return;
      // }
      if (this.idcardPersonImage == "") {
        this.$message.error(this.$t("works.请上传手持证件照正面"));
        return;
      }
      if (this.idcardImageFront == "") {
        this.$message.error(this.$t("global.请上传证件照正面"));
        return;
      }
      if (this.idcardImageBack == "") {
        this.$message.error(this.$t("global.请上传证件照反面"));
        return;
      }
      // if (this.truePhone != this.form.phone) {
      //   this.$message.error(
      //     `${this.$t("global.手机号已修改")}，${this.$t(
      //       "global.请重新获取验证码"
      //     )}`
      //   );
      //   return;
      // }
      this.$http
        .post("/api/u/certification/personal/save", {
          idcardCode: this.form.idcardCode,
          realName: this.form.realName,
          country: this.form.country,
          area: this.form.area,
          // phone: this.form.phone,
          // code: this.form.code,
          idcardImageFront: this.idcardImageFront1 || this.idcardImageFront,
          idcardImageBack: this.idcardImageBack1 || this.idcardImageBack,
          idcardPersonImage: this.idcardPersonImage1 || this.idcardPersonImage,
          sessionId: this.sessionId,
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.personalMessage();
        });
    },
    companyIden() {
      if (this.companyName == "") {
        this.$message.error(this.$t("global.请输入公司名称"));
        return;
      }
      if (this.companyCode == "") {
        this.$message.error(this.$t("global.请输入企业信用代码"));
        return;
      }
      if (this.licenseImage == "") {
        this.$message.error(this.$t("global.请上传执照"));
        return;
      }
      this.$http
        .post("/api/u/certification/company/save", {
          companyName: this.companyName,
          companyCode: this.companyCode,
          licenseImage: this.licenseImage1 || this.licenseImage,
          idcardImageFront: this.companyFront1 || this.companyFront,
          idcardImageBack: this.companyBack1 || this.companyBack,
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.companyMessage();
        });
    },
    sendSms(e) {
      let phone = this.form.phone;
      if (!this.sendFlag) return;
      if (/^[1][0-9]{10}$/.test(phone)) {
        this.truePhone = phone;
        this.$http
          .post("/api/u/certification/sendSms", { phone: phone })
          .then((response) => {
            if (response.code === "OK") {
              this.sendFlag = false;
              this.sessionId = response.data;
              let time = 60;
              this.buttonText = "60s";
              let interval = setInterval(() => {
                time--;
                this.buttonText = `${time}s`;
                if (time === 0) {
                  clearInterval(interval);
                  this.buttonText = this.$t("global.重新发送");
                  this.sendFlag = true;
                }
                if (this.truePhone != phone) {
                  clearInterval(interval);
                  this.buttonText = this.$t("global.重新发送");
                  this.sendFlag = true;
                }
              }, 1000);
            }
          });
      } else {
        this.$message(this.$t("global.请输入正确的手机号"));
      }
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.body {
  background: #FAFAFA;
}

.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;
}

.request {
  margin-top: 0.4rem;
  line-height: 0.4rem;

  .request-head {
    font-size: 0.2rem;
    line-height: 0.49rem;
  }

  .request-content {
    color: #707070;
  }
}

.front-font {
  margin: 0.2rem 0.2rem 0.3rem;
  font-size: 0.16rem;
  text-align: center;
}

.reset-font {
  margin-bottom: 0;
}

.upload-right {
  margin-left: 30px;
}

.upIMG {
  width: 2.7rem;
  height: 2.4rem;
}

.Backimg {
  background: #eeeeee;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 0.18rem;
}

.upload-content {
  display: flex;
  margin-top: 20px;

  .reset-button {
    width: 1.35rem;
    height: 0.5rem;
    line-height: 0.5rem;
    margin: 0.1rem auto 0;
  }

  .front-font {
    margin: 0.2rem auto 0.3rem;
    height: 0.38rem;
  }
}

.upload-head {
  font-size: 0.2rem;
  margin-top: 0.8rem;
  font-weight: bold;

  .tips {
    color: #999999;
    font-size: 0.16rem;
  }
}

.button {
  cursor: pointer;
  width: 118px;
  height: 36px;
  background: #2026CC;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF;
}

.contain {
  display: flex;
  justify-content: space-between;
  margin-top: 0.4rem;

  .font {
    font-size: 0.16rem;
    height: 0.28rem;
    line-height: 0.28rem;
    font-weight: bold;
  }

  .tips {
    color: #999999;
    font-size: 0.16rem;
  }

  input, select, textarea {
    width: 4.5rem;
    height: 0.5rem;
    margin-top: 0.1rem;
    background-color: #F9F9F9;
    border-radius: 0.08rem;
    text-indent: 0.1rem;
    outline: none;
    border: 1px solid #eee;
  }

  #peopleDT {
    height: 2rem;
  }

  .special {
    display: flex;
    justify-content: space-between;
  }

  #area {
    display: block;
    width: 1.22rem;
  }

  .city {
    display: block;
  }

  // width: 3.08rem;
  // margin-left: 0.2rem;
  .resetW {
    width: 14.79rem;
  }
}

.reset-contain {
  justify-content: flex-start;
}

.reset-button {
  margin-left: 12px;
}

.message-top {
  font-size: 0.2rem;
  font-weight: bold;
  padding: 0.8rem 0 0.32rem;
  border-bottom: 2px solid #dddddd;
}

.apply-content {
  width: 825px;
  padding-top: 16px;

  .name {
    height: 30px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 30px;
    margin-bottom: 12px;
  }

  .top-choose {
    width: 100%;
    border-bottom: 1px solid rgba(235, 235, 235, 1);
    position: relative;

    span {
      display: block;
      margin: 0 0.65rem;
    }

    .message {
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      padding: 0 2px;
      margin-right: 40px;
      height: 34px;
      cursor: pointer;
    }

    .modify-password {
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      padding: 0 2px;
      height: 34px;
      cursor: pointer;
    }

    .choose {
      color: #333333;
      font-weight: bold;
      border-bottom: 2px solid rgba(51, 51, 51, 1);
    }
  }

  .basic-message {
    padding: 0 40px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    margin-top: 20px;
  }
}

.summit-apply {
  width: 1.77rem;
  height: 0.5rem;
  margin: 0.5rem auto;
  line-height: 0.5rem;
}

.enterprise-submit {
  margin-top: 1.8rem;
}

.identtips {
  text-align: center;
  margin: 100px 0;
  font-size: 0.2rem;
}
</style>
<style>
.containerApply .el-input__inner {
  width: 4.5rem;
  height: 0.5rem;
  margin-top: 0.1rem;
  background-color: #f9f9f9;
  border-radius: 0.08rem;
  text-indent: 0.1rem;
  outline: none;
  padding-left: 0;
  color: #333;
  font-size: 0.18rem;
  border: 1px solid #eee;
}

.containerApply .el-input__suffix-inner {
  position: relative;
  top: 0.06rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/ApplyIdentification.vue